import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material';

/** Outermost wrapper — shared vertical rhythm for WhiteLabelSettings sections */
export const WhiteLabelSectionRoot = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

/** Divider under the section title */
export const WhiteLabelSectionDivider = styled(Divider)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));
